import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import db from "../../../db/index.json";
import FilterPopup from "../../popup/filterPopup";
import LandlordTable from "../all-landlord/landlordTable";
import LandlordDetail from "./landlordDetail/mainDetail";

const LandlordSection = ({ filterByStatus }) => {
  const { landlord } = db;
  const [showTable, setShowTable] = useState("table");
  const [showFilter, setShowFilter] = useState(false);
  const [detailData, setDetalData] = useState("");
  const [search, setSearch] = useState("");

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (item) => {
    setDetalData(item);
    setShowTable("detail"); // State toggle karein
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };

  return (
    <div className="">
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div className="h-screen w-full">
                <div className="h-[10vh]">
                  <SearchBar
                    title={
                      filterByStatus ? "Pending Landlords" : landlord.title
                    }
                    desc={
                      filterByStatus
                        ? "All landlords pending approval"
                        : landlord.description
                    }
                    onSubmit={openPopup}
                    value={search}
                    onSearchChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    isFilter={true}
                  />
                </div>
                <div className="h-[90vh]">
                  <LandlordTable
                    onViewDetails={toggleDetail}
                    searchTerm={search}
                    filterByStatus={filterByStatus}
                  />
                </div>
              </div>
            );
          case "detail":
            return (
              <LandlordDetail landlordInfo={detailData} onBack={toggleTable} />
            );
          default:
            break;
        }
      })()}
      {showFilter && <FilterPopup onBack={closePopup} onFilter={closePopup} />}
    </div>
  );
};

export default LandlordSection;
